import { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";

import { Loader } from "components/loader/Loader";
import { getResultStatistics } from "views/invoices/Services";
import { removeResultStatistics } from "views/invoices/Actions";

import "./InvoiceStatistics.scss";

const formatNumber = (number) => number.toLocaleString();

export class ResultStatistics extends Component {
  componentDidMount() {
    this.props.dispatch(getResultStatistics(this.props.selectedOffice));
  }

  componentWillUnmount() {
    this.props.dispatch(removeResultStatistics());
  }

  render() {
    const hasData = !_.isEmpty(this.props.resultStatistics);

    return (
      <>
        <div className="invoiceStatisticsContainer">
          {this.props.gettingResultStatistics && <Loader className={"p-4"} />}
          {!this.props.gettingResultStatistics && !hasData && (
            <p>Något gick fel vid hämtningen av statistik</p>
          )}
        </div>

        {hasData && (
          <>
            <div className="header">
              <div className="headerbox">
                <label className="headeritem">Antal fakturor</label>
                <label className="headeritem">
                  {this.props.resultStatistics.invoiceCount + " st"}
                </label>
              </div>
              <div className="headerbox">
                <label className="headeritem">Antal aktiviteter</label>
                <label className="headeritem">
                  {this.props.resultStatistics.activityCount + " st"}
                </label>
              </div>
            </div>

            <div className="yearscontainer">
              <div className="table-wrapper">
                <table className="min-w-400">
                  <thead>
                    <tr>
                      <th>År</th>
                      <th>Öppet PGU</th>
                      <th>Totalt föreslaget</th>
                      <th>Totalt överfört</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.resultStatistics.yearStats
                      .sort((x, y) => {
                        if (x.year > y.year) {
                          return -1;
                        } else if (x.year < y.year) {
                          return 1;
                        }
                        return 0;
                      })
                      .map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>{item.year}</td>
                            <td>{formatNumber(item.totalOpenAmount)}</td>
                            <td>{formatNumber(item.totalSuggestedAmount)}</td>
                            <td>{formatNumber(item.totalTransferredAmount)}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
      </>
    );
  }
}

export default connect((state) => {
  return {
    resultStatistics: state.invoices.resultStatistics,
    gettingResultStatistics: state.invoices.gettingResultStatistics
  };
})(ResultStatistics);
